import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';

/** URL·SunEditor 인코딩 파일명 → 저장용 평문 (HEA_BASIC / HEL_BASIC 패턴) */
export const decodePopBasicFileSegment = (name = '') => {
  if (!name) return '';
  const raw = String(name).replace(/\\/g, '/');
  const base = raw.split('/').pop() || raw;
  try {
    return decodeURIComponent(base.replace(/\+/g, ' '));
  } catch {
    return base;
  }
};

/** PreviewFiles / files URL → moveAndReplace용 상대 경로 */
export const normalizePopBasicPreviewPath = (raw) => {
  if (!raw || typeof raw !== 'string') return '';

  const s = raw.replace(/\\/g, '/');
  const idx = s.indexOf('PreviewFiles/');
  if (idx !== -1) return s.substring(idx);

  const idx2 = s.indexOf('PreviewFiles');
  if (idx2 !== -1) {
    return s.substring(idx2).replace(/^PreviewFiles$/, 'PreviewFiles/');
  }

  const marker = '/files/';
  const urlIdx = s.indexOf(marker);
  if (urlIdx !== -1) {
    const tail = s.substring(urlIdx + marker.length);
    try {
      const decoded = decodeURIComponent(tail);
      const pIdx = decoded.indexOf('PreviewFiles/');
      if (pIdx !== -1) return decoded.substring(pIdx);
      const pIdx2 = decoded.indexOf('PreviewFiles');
      if (pIdx2 !== -1) return decoded.substring(pIdx2);
      return decoded;
    } catch {
      return tail;
    }
  }

  return s;
};

/** 팝업 파일 저장 경로 */
export const buildPopBasicFilePath = (coCd, popId, saveName) => {
  const safeCoCd =
    coCd === undefined || coCd === null || coCd === '' ? 'common' : String(coCd);
  const decodedName = decodePopBasicFileSegment(saveName);
  return `PopupManagement/${safeCoCd}/POP_BASIC/${popId}/${decodedName}`;
};

/** HTML 본문에서 PreviewFiles 경로 추출 */
export const extractPreviewPathsFromHtml = (html = '') => {
  const text = String(html);
  const found = text.match(/PreviewFiles[/\\][^"'\s<>)]+/gi) || [];
  return [
    ...new Set(
      found.map((p) => normalizePopBasicPreviewPath(p.replace(/\\/g, '/')))
    ),
  ];
};

/** CONTENT 내 PreviewFiles URL → 영구 경로 URL 치환 */
export const replacePreviewUrlsInHtml = (html, previewPath, filePath) => {
  if (!html || !previewPath || !filePath) return html;
  const encodedPreview = Commons.EncodeUrl(previewPath);
  const encodedFinal = Commons.EncodeUrl(filePath);
  const base = Global.file.useUrl;
  return String(html)
    .split(`${base}files/${encodedPreview}`).join(`${base}files/${encodedFinal}`)
    .split(previewPath).join(filePath);
};

export const POP_BASIC_FILE_TYPE = {
  ATTACH: 'ATTACH',
  INLINE: 'INLINE',
};

/** 링크 URL 저장값 — 공백만 제거, DB·폼에는 입력 그대로 */
export const normalizePopBasicLinkUrl = (url) => String(url ?? '').trim();

const POP_BASIC_LINK_HAS_PROTOCOL = /^(https?:\/\/|mailto:|tel:|sms:|#)/i;
const POP_BASIC_LINK_DOMAIN_LIKE =
  /^(www\.|[a-z0-9][-a-z0-9]*(\.[a-z0-9][-a-z0-9]*)+)/i;

/** 내부 메뉴 경로 — NoticeBoard, /Home 등 */
const POP_BASIC_LINK_MENU_PATH = /^\/[A-Za-z][A-Za-z0-9]*$|^[A-Za-z][A-Za-z0-9]*$/;

/**
 * 자세히 보기 href — 클릭 시 이동용
 * · 메뉴: 페이지명만 → /페이지명
 * · 외부: www.naver.com 등 → https:// 붙임
 */
export const resolvePopBasicLinkHref = (url) => {
  const value = normalizePopBasicLinkUrl(url);
  if (!value) return '';

  if (POP_BASIC_LINK_HAS_PROTOCOL.test(value)) {
    return value;
  }

  if (POP_BASIC_LINK_MENU_PATH.test(value)) {
    return value.startsWith('/') ? value : `/${value}`;
  }

  if (POP_BASIC_LINK_DOMAIN_LIKE.test(value)) {
    return `https://${value}`;
  }

  return value.startsWith('/') ? value : `/${value}`;
};

/** SunEditor HTML — 텍스트 없이 이미지·링크만 있어도 본문 있음으로 판단 */
export const hasPopBasicEditorContent = (html = '') => {
  const raw = String(html || '').trim();
  if (!raw) return false;

  if (/<img[\s/>]/i.test(raw)) return true;
  if (/<iframe[\s/>]/i.test(raw)) return true;
  if (/<video[\s/>]/i.test(raw)) return true;

  const text = raw
    .replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/[\u200B\uFEFF]/g, '')
    .trim();

  return text.length > 0;
};
